import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="text-center bold mb-3">* * *</p>


    <p class="mb-3">
      Mi skribas ĉi-liniojn en malgranda kafejo survoje al Enotia. 
      Estas trankvile, preskaŭ forestas vojaĝantoj, kaj neeblas kredi, ke nur kelkajn urlojn de ĉi tie furiozas milito, faladas obusoj, kaj pecoj de homa karno disflugas en la ŝtonaj kortoj. 
      Mi loĝis tie dum tri jaroj, travivis malsaton, malvarmon, ruinon, mortojn kaj perfidojn de amikoj – ĉion, kion altrude kaj senelekte proponas al ni milito. Rifuzi ne eblas. 
      Nur hodiaŭ oni min elveturigis kun la lasta konvojo, el tiu loko, kiu iam estis mia Patrujo. 
      Nun tie restis mortaj urboj kaj putrantaj vilaĝoj. Sed iam…
    </p>
  

    <p class="text-center bold mb-3">* * *</p>


    <p class="mb-3">
      Tri jarojn antaŭe oni deklaris, ke ni estas malamikoj de demokratio kaj komencis poiomete eduki nin en la ĝusta senco. 
      Unue aperis pluraj por-Gargejaj organizoj, uzantaj ties fondusojn kaj promociantaj ties valorojn. 
      Verdire, ili aperis jam delonge, sed tiam ilia agado ne estis tiom rimarkebla: ili simple liveris monon al siaj aktivuloj, helpante al ili memstariĝi, ekhavi fortajn sociajn rilatojn kaj do influon. 
      Miaj konatuloj sin nutris de tiuj subvencioj, kaj al la demando, kio okazos al tiuj senhejmaj kompatindaj infanoj, kiam finiĝos la trijara subvencio por ilia subteno, la eminenta pedagogo Arika gaje kaj senzorge ekridis: «Nu, mi skribos novan subvencipeton! Ja temoj multas!». 
      Al miaj provoj klarigi, ke temas ne pri ŝia nutrado, sed pri la nutrado de infanoj, ŝi reagis tre akre, kaj nia komunikado porlonge ĉesis. 
      Ŝi trapasis multajn trejnajn seminariojn kaj bone scias forhaki nebezonatajn demandojn kaj nebezonatajn homojn.
    </p>
    
    <p class="mb-3">
      Nu do, kiam tiuj organizoj sufiĉe maturiĝis, ili komencis montri sin publike. 
      Propagandi siajn ideojn, alvoki al ilia realigo. 
      Kiel idealo, certe, rolis Gargio. 
      Kaj ĉar la vivo ĉe ni tiam estis sufiĉe aĉa, t.e. regis la severa leĝo: «ŝtelu aŭ mortu!», - do, multaj, kiuj sincere deziris ŝteli, sed elpost la larĝaj dorsoj de la venintaj pli frue ne povis kapti eĉ peceton, ekiris tien, kie oni disdonadis la monon libere. 
      Fakte, oni devas fari preskaŭ nenion: kolekti ian etan informon; okazigi tute sendanĝerajn, eĉ soci-utilajn agojn, ekz., la diritan helpon al senhejmaj infanoj; partopreni ian «rondan tablon»; krei kaj plenigadi ttt-ejon, subteni fremdajn similajn ttt-ejojn… 
      Ja negranda laboro: skribi kelkdek mesaĝojn tage, kurtajn, kvazaŭ preterajn – sed mono ja gutas! 
      Tiun vojon sekvante, oni povas poiomete fariĝi biznesulo, se la kapitalo akumuliĝis, - sed prefere resti volontulo, ne riskante sian havaĵon aŭ monrimedojn. 
      Tia modesta, nerimarkinda aktivulo reale estas la parto de granda forto, ĉelo de tutmonda reto. 
    </p>
    
    <p class="mb-3">
      Kaj kiam estis atingita la krita maso kaj la reto kovris la tutan landon, tiam komenciĝis elpaŝoj sur placoj. 
      Komenciĝis popolaj agoj, al kiuj denove hastis la samaj homoj, kiuj ne sukcesis ŝteli aŭ sukcesis ne tiom, kiom volis, ĉar la plimulton de la predo forprenis de ili tiuj, kiuj venis al la nutrotrogo pli frue. 
      Kaj de la alia flanko – vilaĝanoj, kiuj ne ŝtelis nur pro la manko de kapabloj kaj foresto de tio, kion eblus ŝteli. Nu, kompreneble, ankaŭ la juna generacio, nia apogo kaj futuro, ĉiam preta saltadi kaj kriadi kontraŭ «dikaj patroj» kun espero iam okupi iliajn lokojn. 
    </p>
    
    <p class="mb-3">
      Jen pri infanoj estas interesa afero. 
      Ĉi tie klare videblas, ke nia milito tute ne estis subita. 
      Jam 20 jarojn niajn infanojn edukadis malamikoj, preparigante ilin por milito kontraŭ ni. 
      Mi memoras, ke kiam ĉe ni okazis la lasta malsato, la registaro ne altigis la salajrojn al instruistoj – ĝi male, tute ĉesis financi la edukadon kaj sciencon. 
      Instruistoj, por elvivi, venis al stratoj por vendaĉi ion ajn, en lernejoj oni tute ne zorgis pri infanoj, nek klerige, nek eduke: tiam oni konsideris NORMALA afero, ke knaboj deziras esti banditoj, kaj knabinoj – putinoj, ĉar nur tiuj du kategorioj tiam havis monon kaj vivis bonhave. 
      Tamen, per la ŝparita je instruistaj salajroj mono oni reverkis la lernolibrojn, por modli el niaj infanoj malgrandajn gargianojn, kvankam ili loĝis tute ne en Gargio. 
      Kion do tiuj infanoj povis fari? 
      Certe postuli, impeti ien, dezirante fari el sia lando la adoratan Gargion. 
      Kaj en lernejoj ilin jam atendis Babosaj geinstruistoj, ricevantaj subvenciojn el Gargio…
    </p>
    
    <p class="mb-3">
      Kaj jen, antaŭ 3 jaroj io tio fin-fine eksplodis. 
      Komence tumultoj sur la placo en ĉefurbo; poste – en grandaj urboj… kaj malgrandajn urbojn neniu eĉ demandis, ĉu ili deziras ribeli: eku kaj obeu! 
      Tie, tute subite, jam armitaj, kiel Atena el la kapo de Zeŭso, aperis taĉmentoj de partuj-defendantoj, senprokraste alproprigintaj kaj la potencon, kaj la havaĵon de malpli lerta ularo.
    </p>
    
    <p class="mb-3">
      Parto de la lando provis kontraŭstari – sed nur tiu parto, kiu havis landlimon kun Kumbio, ankaŭ granda lando, kaj konstanta oponanto de Gargio. 
      Ĉio, kio troviĝis pli foren de la limo, restis en severa ĉirkaŭpremo kaj iĝis pli kaj pli senkompate deprimita. 
      Edifa leciono por ribelintoj fariĝis «ekzekuto per glavo kaj fajro» en Ivaro, senzorga ĉemara urbo, fama pro kuraclokoj kaj komerca haveno. 
      Tie oni bruligis vivajn ĉirkaŭ centon da civitanoj, kunvenintaj en unu el klubejoj por «Konferenco por formado de kompreno pri la aktuala situacio». 
      Nenio tiel kontraŭas al la gargia vivsistemo, kiel emo de simplaj homoj KOMPRENI. 
      Tiun infekton endas forbruligi per ardanta fero, por ke ĝi ne stumbligu la gvidantojn. 
      Kaj oni forbruligis. 
      En la rekta senco de la vorto… 
      Tiujn, kiuj provis saviĝi el la flamanta konstruaĵo, malsupre oni mortbatis per bastonoj kaj per kruroj. 
      Tre prudente kaj racie planita operacio de timigo. 
    </p>
    
    <p class="mb-3">
      Post tio la tuta lando eksilentis kaj sin kaŝis ferminte la okulojn. 
      Komenciĝis la sekva etapo: senbrua sufokigo de silentuloj. 
      Ĉiunokte oni forprenadis realajn kaj imagitajn «malamikojn de l’ popolo». 
      La restintaj devis mimetismi por elvivi. 
      Ili unuaj elpendadis frambo-violkoloran standardon de la reganta reĝimo, kriis ĉe renkonto «Gugu ban!» (oficiala saluto, anstataŭ la kutima «Saluton!» aŭ «Bonan tagon!»). 
      Al tio endis respondi: «Ban bariba!», kaj nerespondintajn oni tuj batadis feroce. 
      Sed ne multaj arogis ne respondi; kaj la semo de kovardeco kaj perfidemo protima pli kaj pli kreskis en animoj de «simplaj homoj, ne dezirantaj batali». 
    </p>
    
    <p class="mb-3">
      Sed la milito proksimiĝis. 
      Por ĝi oni mobilizis pli kaj pli multajn ŝtatanojn, kaptante ilin eĉ surstrate kaj en publikaj trafikiloj. 
      Kaj post unuaj mortoj kreskis krueleco, kaj la milito por la potenco de Gargio poiomete transformiĝis en la militon de ĉiuj kontraŭ ĉiuj sur la teritorio de nia povra Burbugo. 
      Ĉiu regiono armiĝis per sia propra armeeto kaj pretis sin defendi kontraù ĉiuj aliuj. 
      Spionoj, partizana milito – nenio evitis nin!
    </p>
    
    <p class="mb-3">
      Precipe terura estis la unua jaro, kiam la popolo ankoraŭ ne ekkonsciis plene, ke la milito jam ekis, kaj ne sukcesis prepariĝi por la vintro. Daŭre ŝajnis, ke ĉio tio estas absurdo, sensencaĵo, malbona sonĝo, de kiu ni povus vekiĝi, ke la aferoj iel mem stabiliĝos, ĉio pasos… Tre multaj homoj mortis tiuvintre – sen elektro, sen varmo kaj akvo. Sed, kiel strange, la ĉefa priparolata kaj priplorata kialo de senespero estis foresto de Interreto, televido kaj elektro por ŝargi la mobilajn telefonojn. Homojn obsedis vera abstina krizo pro senigo de objektoj de artefarite kreita bezono. Tre multaj freneziĝis, ne elteninte profundan vakuon en sia cerbo. Ja ili delonge dekutimiĝis legi, pensi, interpretadi la okazaĵojn. La tutan informon, ĉiujn pensojn ili ricevadis pretajn el ekranoj de komputiloj kaj televidiloj; kaj kiam tiu kanalo estis barita, tiam ululanta, silbanta vakuo ekregis ilian cerbon, kaj la cerbo ne plu povis regi la sensencan korpon…
    </p>
    
    <p class="mb-3">
      Homoj komencis manĝi unu la alian en la rekta kaj nerekta senco. 
      Okazis ondo de priraboj, kaj multaj de ili estis sufiĉe bizaraj. 
      Vi scias, certe, ke en komputila epoko oni ĉesis legi librojn, kontentigante sin per bildetoj surekrane. 
      Hejmaj bibliotekoj, kiujn oni kolektis dum multaj jaroj, kaj ofte eĉ dum la vivoj de kelkaj generacioj, estis ĝoje forĵetataj al rubujo far feliĉaj heredantoj de olda furzulo, kiu fin-fine mortis, liberiginte por ili la loĝareon. 
    </p>
    
    <p class="mb-3">
      En la novaj loĝejoj ne estis loko por libroj; tie estis loko por… 
      Por kio? 
      Neniu scias. 
      Verŝajne, por tiu sama vakuo, kiu regis en la cerboj kaj animoj de iliaj posedantoj.
    </p>
    
    <p class="mb-3">
      Do jen: librojn oni forĵetadis. 
      Tradukistoj feliĉarde sin liberigis de centkilogramaj vortaroj, por sin inici al la plej novaj atingoj de la civilizacio en formo de diversaj KAToj – aŭtomataj sistemoj de traduko. 
      Tiuj sistemoj neimageble plifaciligis la vivon de tradukisto, plialtigis la rendimenton… 
      Kaj kiam ĉio tia falis en abismon, evidentiĝis, ke multaj mojosaj tradukistoj ne konas la lingvon, ne scipovas uzi la paperan vortaron, kaj eĉ simple dekutimiĝis skribi permane! 
      Kaj, dum ilia laboro ankoraŭ estis bezonata, okazadis priraboj, kiam la celo de rabistoj estis … vortaroj! 
      Pli bonhavaj kolegoj dungis rabistojn, por ke tiuj alportu al ili eblecon daŭrigi mondonan laboron kaj sametempe forigu la konkurantojn. 
      Mi scias tion, ĉar mi interkomunikis kun tia medio, kaj kelkajn miajn konatojn tiamaniere oni prirabis, iun eĉ mortigis, kaj multaj aliuj interflustris, ke tio okazis laŭ la mendo de aliaj miaj konatoj, kiuj jam en «papera» medio sukcesis daŭrigi sian negocon. 
    </p>
    
    <p class="mb-3">
      Kompreneble, eĉ pli malbone estis en inĝenieraj kaj sciencaj rondoj, kie necesas kalkuloj, desegnaĵoj, konatiĝo kun plej novaj atingoj en sia tereno. 
      Malapero de Interreto fakte neniigis la tutan praktikan agadon en tiu sfero. 
      La homo tiel ĝoje fordonis ĝin al maŝinoj – kaj subite okazis, ke maŝinoj povas panei, kaj la homo mem jam forkutimiĝis fari ĉion tion mem. 
      Feliĉe, ke al neniu jam bezonatis scienco kaj tekniko…
    </p>
    
    <p class="mb-3">
      En tiu unua malluma kaj malvarma vintro, laŭ la stratoj marŝadis armitaj patroloj kaj forpafadis sennombrajn frenezulojn, vagantajn sencele. 
      Al siaj familioj ili ne estis bezonataj, ĉar en familioj ne estis kion manĝi eĉ por «aktivaj» membroj. 
      Sed pragmata registaro trovis por tiuj sencerbuloj tre racian uzon… 
      Multaj, multaj malfeliĉuloj estis savitaj en aliaj partoj de la mondo… 
      Sed pri tiuj aferoj mi tute ne volas paroli. 
    </p>
    
    <p class="mb-3">
      Tiuj, kiuj travivis unuan vintron, ĝisvivis ĝis legomĝardenoj. 
      Renaskiĝis metioj: tre bezonata okazis scipovo kudri vestaĵojn kaj ŝuaĵojn. 
      Aperis malgrandaj hejmaj lernejoj, eĉ klasoj, kie infanojn oni instruis laŭ la konservitaj libroj. 
      Kiel sopire oni rememoris tiam stakojn da libroj en rubujoj! 
      Sed per libroj en tiu vintro oni ankaŭ hejtis ĉambrojn… 
      Kiel malvarme estis en malplenaj loĝejoj!
    </p>
    
    <p class="mb-3">
      Kaj la mondo trankvile rigardis al mortanta Burbugo. 
      Ĉiu havas siajn zorgojn. 
      Fin-fine, ili havas tie bonegajn grundojn, rarajn minaĵojn – sed ia biomaso rampas sur ili kaj malhelpas uzi tiujn riĉaĵojn civilizite. 
      Sed estas ja tiuj, kiuj povus ilin uzi racie! Kaj jen, komencis faladi sur niajn kapojn oni-ne-scias-kies obusoj. 
      Laŭ la lupa leĝo: la tuta luparo al senfortulo, por disŝiri kaj formanĝi lian korpon. 
    </p>
    
    <p class="mb-3">
      Adiaŭ, la lando Burbugo! 
      Adiaŭ, la standardo frambo-violkolora! 
      Disŝirita per eksplodoj, malpurigita per brulaĵo, vi flirtas super mortaj urboj kaj putrantaj vilaĝoj. 
      Jam preskaŭ neniu tie restis, kaj baldaŭ novaj gemastroj venos sur la kripligitan teron. 
      Ili ne rememoros, nek per bona, nek per malbona vorto, tiujn, kiuj loĝis sur tiu tero antaŭe. 
      Ili, antaŭaj, elpensis por la duono de siaj civitanoj la nomon «biologia rubaĵo». 
      Jen ili mem fariĝis rubaĵo, kaj estas forbalaitaj de la vizaĝo de la tero kaj pravaj, kaj malpravaj.
    </p>
    
    <p class="mb-3">
      Tiel finiĝis Burbugo, kiu ekdeziris esti La Granda Burbugo… sed ne ekpovis. 
      La Grandaj ne naskiĝas el servado kaj fremdaj ordonoj.
    </p>
    
    <p class="mb-3">
      Kaj mi iras al Enotio. 
      Al oriento, kie la suno kaj la lumo.
    </p>
  `
  )
}

const itemName = {
  esp: 'Rakonto de ĉeestinto'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp,
    itemDate: '27 sept, 2014'
  }
}

export default item;
